if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        this.handleDesignerBlock();
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading-overlay').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading-overlay').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (const selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step', 'data-allowed'];
            for (const attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      handleDesignerBlock() {
        const designerSection = document.getElementById('designer-section');
        if (!designerSection) {
          const designerBlocks = document.querySelectorAll('.product__designer');

          designerBlocks.forEach((block) => {
            const designerLink = block.querySelector('a');

            if (designerLink.textContent.trim() !== '') {
              const text = designerLink.textContent.trim();
              const span = document.createElement('span');
              span.textContent = text;
              const spanWrapper = designerLink.parentElement;
              if (spanWrapper && spanWrapper.tagName.toLowerCase() === 'span') {
                spanWrapper.innerHTML = '';
                spanWrapper.appendChild(span);
              } else {
                designerLink.replaceWith(span);
              }
            }
          });
        }
      }
    },
  );
}

document.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.querySelector('.desktop-dimensions-image-wrapper');
  const thumb = document.querySelector('.custom-scrollbar-thumb');
  const track = document.querySelector('.custom-scrollbar-track');

  if (!wrapper || !thumb || !track) return;

  let trackWidth = 0;
  let thumbWidth = 0;
  let maxThumbLeft = 0;
  let isDragging = false;
  let startX, startScrollLeft;

  function updateThumb() {
    trackWidth = track.offsetWidth;
    const scrollWidth = wrapper.scrollWidth;
    const clientWidth = wrapper.clientWidth;

    if (trackWidth === 0 || scrollWidth === 0) return; // Prevent bad calc

    if (scrollWidth <= clientWidth) {
      thumb.style.width = `${trackWidth}px`;
      thumb.style.transform = `translateX(0px)`;
      return;
    }

    thumbWidth = (clientWidth / scrollWidth) * trackWidth;
    maxThumbLeft = trackWidth - thumbWidth;

    const scrollLeft = wrapper.scrollLeft;
    const thumbLeft = (scrollLeft / (scrollWidth - clientWidth)) * maxThumbLeft;

    thumb.style.width = `${thumbWidth}px`;
    thumb.style.transform = `translateX(${thumbLeft}px)`;
  }

  function scrollFromThumb(dx) {
    const scrollWidth = wrapper.scrollWidth;
    const clientWidth = wrapper.clientWidth;
    if (maxThumbLeft === 0) return;

    const thumbMovementRatio = dx / maxThumbLeft;
    wrapper.scrollLeft = startScrollLeft + thumbMovementRatio * (scrollWidth - clientWidth);
  }

  // Listen for wrapper scroll and window resize
  wrapper.addEventListener('scroll', updateThumb);
  window.addEventListener('resize', updateThumb);

  // Update when images load
  const images = wrapper.querySelectorAll('img');
  images.forEach(img => {
    if (img.complete) {
      updateThumb();
    } else {
      img.addEventListener('load', updateThumb);
    }
  });

  // Observe element size changes
  const ro = new ResizeObserver(updateThumb);
  ro.observe(wrapper);
  ro.observe(track);

  // Mouse dragging
  thumb.addEventListener('mousedown', (e) => {
    isDragging = true;
    startX = e.clientX;
    startScrollLeft = wrapper.scrollLeft;
    document.body.style.userSelect = 'none';
  });

  document.addEventListener('mousemove', (e) => {
    if (!isDragging) return;
    const dx = e.clientX - startX;
    scrollFromThumb(dx);
  });

  document.addEventListener('mouseup', () => {
    isDragging = false;
    document.body.style.userSelect = '';
  });

  // Touch dragging
  thumb.addEventListener('touchstart', (e) => {
    if (e.touches.length !== 1) return;
    isDragging = true;
    startX = e.touches[0].clientX;
    startScrollLeft = wrapper.scrollLeft;
    document.body.style.userSelect = 'none';
  }, { passive: true });

  document.addEventListener('touchmove', (e) => {
    if (!isDragging || e.touches.length !== 1) return;
    const dx = e.touches[0].clientX - startX;
    scrollFromThumb(dx);
  }, { passive: true });

  document.addEventListener('touchend', () => {
    isDragging = false;
    document.body.style.userSelect = '';
  });

  // Final safety: run once after everything
  window.addEventListener('load', updateThumb);
});

